module.exports = __webpack_public_path__ + "img/why-1.6b09fa7a.webp";